import React from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Card,
  Chip,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const stockItems = [
  {
    name: "A B.COVER RR CZ-3 15-18 No Sen",
    code: "MDK1545NBF",
    status: "Out of Stock",
    remaining: 0,
  },
  {
    name: "Bar Cover Front No Mould Holes",
    code: "F5A1540NAA",
    status: "Out of Stock",
    remaining: 0,
  },
  {
    name: "Bar Cover Front Chrome",
    code: "ZA21540NBA",
    status: "Low",
    remaining: 10,
  },
  {
    name: "Bar Mould Left Hand Front Lower Chrome",
    code: "ZA21540NBA",
    status: "Low",
    remaining: 5,
  },
  {
    name: "Head Lamp Left Hand Upper No Xenon",
    code: "F5A4500NCL",
    status: "Low",
    remaining: 1,
  },
];

const getStatusColor = (status) => {
  switch (status) {
    case "Out of Stock":
      return "#F45B6991";
    case "Low":
      return "#F74B004A";
    default:
      return "default";
  }
};

const LowQuantityStock = () => {
  const navigate = useNavigate();

  const viewLowQualityStocks = () => {
    navigate("/super-admin/stocks", {
      state: {
        type: "Under Threshold",
        isFromDashboard: true,
      },
    });
  };

  return (
    <Grid item xs={12} md={4}>
      <Card sx={{ height: "100%" }}>
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ padding: "16px 16px 0 16px" }}
          >
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Lexend",
                fontSize: "24px",
                fontWeight: 500,
              }}
            >
              Low Quantity Stock
            </Typography>
            <Button
              size="small"
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                color: "#7152F3",
                textTransform: "none",
                paddingRight: 0,
              }}
              onClick={viewLowQualityStocks}
            >
              See All
            </Button>
          </Box>

          {stockItems.map((item, index) => (
            <>
              <Box
                sx={{
                  padding: "16px",
                }}
              >
                <Grid key={index} container spacing={3}>
                  <Grid item md={8}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#AA3028",
                        lineHeight: "20px",
                        fontFamily: "Lexend",
                        textAlign: "left",
                        marginBottom: "6px",
                      }}
                    >
                      {item?.name.length > 32
                        ? item?.name?.slice(0, 32).concat("...")
                        : item.name}
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item md={8}>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            fontFamily: "Lexend",
                            color: "#667085",
                            textAlign: "left",
                          }}
                        >
                          {item.code}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        md={4}
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          fontFamily: "Lexend",
                          color: "#667085",
                          whiteSpace: "nowrap",
                          display: "flex",
                        }}
                      >
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{
                            marginRight: "8px",
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            fontFamily: "Lexend",
                            color: "#667085",
                          }}
                        >
                          {`Remaining: ${item.remaining}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    md={4}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Chip
                      label={item.status}
                      sx={{
                        color: "#AA3028",
                        backgroundColor: getStatusColor(item.status),
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Box>
              <Divider />
            </>
          ))}
        </>
      </Card>
    </Grid>
  );
};

export default LowQuantityStock;
